import contract, { ThemeTypographyKeys as ThemeTypographyKeysContract } from './themes/contract.css'

export type ThemeKeys = typeof contract

export type ThemeColors = typeof contract.palette

export const theme = contract

export type ThemeTypographyKeys = ThemeTypographyKeysContract
